import { render, staticRenderFns } from "./AdminCollaborator.vue?vue&type=template&id=40d08e4b"
import script from "./AdminCollaborator.vue?vue&type=script&lang=js"
export * from "./AdminCollaborator.vue?vue&type=script&lang=js"
import style0 from "./AdminCollaborator.vue?vue&type=style&index=0&id=40d08e4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports